import moment from "moment-timezone";

// Konfiguracje trzech list Magazynu Warszawa renderowanych przez MagazynListPage.
// Rozni je tylko: endpoint, kolumny, dostepne filtry, raport XLSX i lista osob
// uprawnionych do usuwania. Reszta (tabela, filtry, zaznaczanie, komentarze zbiorcze) jest wspolna.

const joinComments = (comments) =>
  comments.length > 0
    ? comments
        .map((c) => `${c.comment} (${moment(c.created_at).format("DD.MM.YYYY HH:mm")})`)
        .join(" | ")
    : "";

const DELETE_ROLES = ["admin", "manager"];

// Typy filtrow: multi = wielokrotny wybor z wartosci w danych (albo `options`),
// yesno = Tak/Nie, text = fragment tekstu, nrRef = wiele numerow po przecinku/liniach.
const STATUS_OPTIONS = ["Do przygotowania", "Zrealizowane", "Anulowane"];

export const ARCHIWUM_ODPRAWA_CELNA = {
  id: "archiwumOdprawaCelna",
  path: "/magazynWarszawa",
  view: "magazynWarszawa",
  title: "Archiwum Odprawa Celna",
  noun: "zgłoszeń",
  endpoint: "/userMagazynWarszawa",
  detailFrom: "magazynWarszawa",
  localTime: false,
  deleteRoles: DELETE_ROLES,
  deleteUsernames: [
    "adobrowolska",
    "ahrechaniuk",
    "dczernikowska",
    "molszewska",
    "dwieteska",
    "eleszek",
    "aforys",
  ],
  columns: [
    { id: "statusRealizacji", label: "Status", width: 170, kind: "status" },
    { id: "createdBy", label: "Utworzono przez", width: 170 },
    { id: "utworzono", label: "Data utworzenia", width: 140, kind: "date" },
    { id: "numerListu", label: "Nr listu przewozowego", width: 190 },
    { id: "nadawca", label: "Nazwa firmy (nadawca)", width: 200 },
    { id: "rodzaj", label: "Rodzaj", width: 170 },
    { id: "liczbaPaczek", label: "Liczba paczek", width: 120 },
    { id: "liczbaPalet", label: "Liczba palet", width: 120 },
    { id: "MRN", label: "MRN", width: 190 },
    { id: "iloscPozycjiSAD", label: "Ilość pozycji SAD", width: 130 },
    { id: "rewizja", label: "Rewizja", width: 100, kind: "yes" },
    { id: "kierunek", label: "Kierunek", width: 120 },
    { id: "serwisLotniczy", label: "Serwis lotniczy", width: 150 },
    { id: "endDate", label: "Data zakończenia", width: 160, kind: "dateTime" },
    { id: "ileWSystemie", label: "Ile w systemie", width: 130, kind: "elapsed" },
  ],
  filters: [
    { key: "statusRealizacji", label: "Status", type: "multi", options: STATUS_OPTIONS },
    { key: "rodzaj", label: "Rodzaj", type: "multi" },
    { key: "kierunek", label: "Kierunek", type: "multi" },
    { key: "createdBy", label: "Utworzono przez", type: "multi" },
    { key: "rewizja", label: "Rewizja", type: "yesno" },
    { key: "MRN", label: "MRN", type: "text" },
  ],
  ranges: [
    { key: "created", label: "Data utworzenia", field: "utworzono" },
    { key: "ended", label: "Data zakończenia", field: "endDate" },
  ],
  presets: [{ id: "rewizja", label: "Rewizja", hint: "Zgłoszenia z rewizją", filter: "rewizja", value: "Tak" }],
  legend: [{ label: "Rewizja", background: "#fffde7", stripe: "#f57c00" }],
  tint: (row) => (/^tak$/i.test(row.rewizja || "") ? "warn" : ""),
  bulkNoun: "odpraw",
  report: {
    title: "Raport - zakres dat zakończenia i kierunek",
    dateField: "endDate",
    directions: true,
    sheet: "Raport",
    fileName: (start, end, suffix) =>
      `Raport_${moment.utc(start).format("DD_MM_YYYY")}_${moment.utc(end).format("DD_MM_YYYY")}${suffix}.xlsx`,
    row: (item, comments) => ({
      "Nr. Zlecenia/nrRef": item.nrRef || "",
      // Uwaga: kolumna "Data zakończenia" w tym raporcie historycznie zawiera date utworzenia.
      "Data zakończenia": moment.utc(item.utworzono).format("DD.MM.YYYY"),
      "Numer listu przewozowego": item.numerListu || "",
      "Nazwa firmy/nadawca": item.nadawca || "",
      Paczki: item.liczbaPaczek || "",
      Palety: item.liczbaPalet || "",
      "Koszt handlingu": "",
      MRN: item.MRN || "",
      "Ilość pozycji SAD": item.iloscPozycjiSAD || "",
      "Koszt odprawy": "",
      Rewizja: item.rewizja || "",
      Kierunek: item.kierunek || "",
      "Serwis lotniczy": item.serwisLotniczy || "",
      "Osoba tworząca zgłoszenie": item.createdBy || "",
      Komentarze: joinComments(comments),
    }),
  },
};

export const HANDLING = {
  id: "handling",
  path: "/magazynWarszawaHandling",
  view: "magazynWarszawaHandling",
  title: "Archiwum Handling",
  noun: "zgłoszeń",
  endpoint: "/userMagazynWarszawaHandling",
  detailFrom: "magazynWarszawaHandling",
  localTime: true,
  deleteRoles: DELETE_ROLES,
  deleteUsernames: ["adobrowolska", "aniedbalski", "ahrechaniuk", "dczernikowska", "molszewska"],
  columns: [
    { id: "createdBy", label: "Utworzono przez", width: 170 },
    { id: "utworzono", label: "Data utworzenia", width: 140, kind: "date" },
    { id: "numerListu", label: "Nr listu przewozowego", width: 190 },
    { id: "nadawca", label: "Nazwa firmy", width: 200 },
    { id: "liczbaPaczek", label: "Liczba paczek", width: 120 },
    { id: "liczbaPalet", label: "Liczba palet", width: 120 },
    { id: "kierunek", label: "Kierunek", width: 120 },
  ],
  filters: [
    { key: "kierunek", label: "Kierunek", type: "multi" },
    { key: "createdBy", label: "Utworzono przez", type: "multi" },
  ],
  ranges: [{ key: "created", label: "Data utworzenia", field: "utworzono" }],
  presets: [],
  legend: [],
  tint: () => "",
  bulkNoun: "zgłoszeń",
  report: {
    title: "Raport Handling - zakres dat",
    dateField: "utworzono",
    directions: false,
    sheet: "Raport_Handling",
    fileName: (start, end) =>
      `Raport_Handling_${moment(start).format("DD_MM_YYYY")}_${moment(end).format("DD_MM_YYYY")}.xlsx`,
    row: (item, comments) => ({
      "Nr. Zlecenia/nrRef": item.nrRef || "",
      "Data utworzenia": moment(item.utworzono).format("DD.MM.YYYY"),
      "Numer listu przewozowego": item.numerListu || "",
      "Nazwa firmy/nadawca": item.nadawca || "",
      Paczki: item.liczbaPaczek || "",
      Palety: item.liczbaPalet || "",
      "Koszt handlingu": "",
      MRN: "",
      "Ilość pozycji SAD": "",
      "Koszt odprawy": "",
      Rewizja: "",
      Kierunek: item.kierunek || "",
      "Osoba tworząca": item.createdBy || "",
      Komentarze: joinComments(comments),
    }),
  },
};

export const ZWROTY_I_BLEDY = {
  id: "zwrotyIBledy",
  path: "/magazynWarszawaZwrotyIBledy",
  view: "magazynWarszawaZwrotyIBledy",
  title: "Zwroty i błędy",
  noun: "zgłoszeń",
  endpoint: "/userMagazynWarszawaZwrotyIBledy",
  detailFrom: "magazynWarszawaZwrotyIBledy",
  localTime: false,
  deleteRoles: DELETE_ROLES,
  deleteUsernames: ["adobrowolska", "aniedbalski", "ahrechaniuk", "dczernikowska", "molszewska"],
  columns: [
    { id: "createdBy", label: "Utworzono przez", width: 170 },
    { id: "nadawca", label: "Nazwa firmy (nadawca)", width: 200 },
    { id: "utworzono", label: "Data utworzenia", width: 140, kind: "date" },
    { id: "numerListu", label: "Nr listu przewozowego", width: 190, kind: "duplicate" },
    { id: "liczbaPaczek", label: "Liczba paczek", width: 120 },
    { id: "bladDokumentacji", label: "Błąd dokumentacji", width: 170 },
    { id: "rodzajBledu", label: "Rodzaj błędu", width: 170 },
    { id: "zwrot", label: "Zwrot", width: 130 },
    { id: "powod", label: "Powód zwrotu", width: 190 },
    { id: "wniosek", label: "Wniosek", width: 150 },
  ],
  filters: [
    { key: "createdBy", label: "Utworzono przez", type: "multi" },
    { key: "bladDokumentacji", label: "Błąd dokumentacji", type: "multi" },
    { key: "rodzajBledu", label: "Rodzaj błędu", type: "multi" },
    { key: "zwrot", label: "Zwrot", type: "multi" },
    { key: "duplikat", label: "Duplikat numeru listu", type: "yesno", test: (row) => row.duplikat === 1 },
  ],
  ranges: [{ key: "created", label: "Data utworzenia", field: "utworzono" }],
  presets: [
    {
      id: "duplikat",
      label: "Duplikaty",
      hint: "Numer przesyłki już istnieje w bazie",
      filter: "duplikat",
      value: "Tak",
    },
  ],
  legend: [{ label: "Duplikat: numer przesyłki już istnieje w bazie", background: "#fff1f1", stripe: "#d32f2f" }],
  tint: (row) => (row.duplikat === 1 ? "danger" : ""),
  bulkNoun: "zgłoszeń",
  report: {
    title: "Raport Zwroty i błędy - zakres dat",
    dateField: "utworzono",
    directions: false,
    sheet: "Raport_Zwroty_i_Bledy",
    fileName: (start, end) =>
      `Raport_Zwroty_i_Bledy_${moment(start).format("DD_MM_YYYY")}_${moment(end).format("DD_MM_YYYY")}.xlsx`,
    row: (item, comments) => ({
      "Nr. Zlecenia/nrRef": item.nrRef || "",
      "Data utworzenia": moment.utc(item.utworzono).format("DD.MM.YYYY"),
      "Nr. Listu przewozowego": item.numerListu || "",
      "Klient rabatowy": "",
      Paczki: item.liczbaPaczek || "",
      Zwrot: item.zwrot || "",
      "Powód zwrotu": item.powod || "",
      "Dodatkowe opłaty": "",
      "Osoba tworząca": item.createdBy || "",
      Komentarze: joinComments(comments),
      // Potrzebne do arkusza "Błędy".
      "Błąd Dokumentacji": item.bladDokumentacji || "",
      "Rodzaj błędu": item.rodzajBledu || "",
    }),
  },
};
